/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useRef } from 'react';
import {
    array,
    arrayOf,
    bool,
    func,
    number,
    object,
    shape,
    string,
} from 'prop-types';
import Media from 'react-media';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import { useHistory } from 'react-router-dom';
import FilterIcon from '../../../../BrandTheme/Icons/FilterSvgIcon';
import DesktopProductFacetsV3 from './DesktopProductFacetsV3';
import MobileProductFacetsV3 from './MobileProductFacetsV3';
import { getFeatureFlags } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import useCheckedFacets from '../../../../../helpers/hooks/useCheckedFacets';
import { FilterDialog } from '../FilterDialog/FilterDialog';
// import useSSRMediaQuery from '../../../../../helpers/hooks/useSSRMediaQuery';

const MobileDesktopFacetsV3 = ({
    isFoodBrand,
    classes,
    productFacetsBase,
    isFacetFiltersCountEnabled,
    filterFlag,
    category,
    trackEventAction,
    categoryData,
    abCategorySortAndFilter,
    isFilterFactsV2,
    isDesktopFacetsV3,
    isMobileFacetsV3,
    featureFlags,
    displayDeliveryMethod,
    setFacetsDataInCollection,
    setFilterDataInCategoryBuilder,
    presentation_family,
    openFacetDropdown,
    setFacetLabel,
    productCount,
    ssrDeviceType,
    productDisplayLayout,
    selectedFacet,
    forPlantGuide,
}) => {
    const history = useHistory();
    const checkedFacetsData = useCheckedFacets();
    const [checkedOptions, setCheckedOptions] = useState(checkedFacetsData);
    const containerRef = useRef();
    // const device = useSSRMediaQuery();

    const selectionChanged = (data) => {
        setCheckedOptions(data);
    };

    const resetChecked = () => {
        trackEventAction({
            eventCategory: 'Category Page',
            eventAction: 'Filter Interaction - Clear All',
            eventName: 'feature_interaction', // Requird for GA4 feature_click
            eventLabel: 'Filter Clear All',
        });
        history.push({
            search: '',
        });
        setCheckedOptions([]);
        setFacetsDataInCollection([]);
    };

    // filter sorting dialog
    const filterDialogData = () => category !== null && abCategorySortAndFilter !== 'hide' && (
        <FilterDialog
            cmsFilterFlag={categoryData?.content?.entries?.[0]?.show_filters}
            isFilterFactsV2={isFilterFactsV2}
            isDesktopFacetsV3={isDesktopFacetsV3}
            isMobileFacetsV3={isMobileFacetsV3}
            filterFlag={filterFlag}
            track={trackEventAction}
            featureFlags={featureFlags}
            displayDeliveryMethod={displayDeliveryMethod}
            setFacetsOptions={setFacetsDataInCollection}
            setFilterOptions={setFilterDataInCategoryBuilder}
            presentation_family={presentation_family}
            brand={categoryData?.brand}
            productFacets={productFacetsBase}
            category={category}
            selectedFacet={selectedFacet}
        />
    );

    // use for Filter SVG icon
    const svgIconData = (classFilter, toggleFilterData, selectedFilters = null) => (
        toggleFilterData ? (
            <>
                <span>Hide Filters </span>
                <CloseIcon className={classFilter.hideFilters} />
            </>
        ) : (
            <>
                <span>Filter{selectedFilters ? ` (${selectedFilters})` : ''}</span>
                <FilterIcon />
            </>
        )
    );
    return (
        <Media query={{ maxWidth: 1024 }} defaultMatches={ssrDeviceType === 'desktop'}>
            {(smallScreens) => (!smallScreens ? (
                <div ref={containerRef} className={classes.stickyFacetsContainer}>
                    <DesktopProductFacetsV3
                        isFoodBrand={isFoodBrand}
                        classes={classes}
                        productFacetsBase={productFacetsBase}
                        isFacetFiltersCountEnabled={isFacetFiltersCountEnabled}
                        category={category}
                        trackEventAction={trackEventAction}
                        categoryData={categoryData}
                        setFacetsDataInCollection={setFacetsDataInCollection}
                        svgIconData={svgIconData}
                        filterDialogData={filterDialogData}
                        checkedOptions={checkedOptions}
                        setCheckedOptions={selectionChanged}
                        openFacetDropdown={openFacetDropdown}
                        setFacetLabel={setFacetLabel}
                        resetChecked={resetChecked}
                        productCount={productCount}
                        containerRef={containerRef}
                        selectedFacet={selectedFacet}
                        forPlantGuide={forPlantGuide}
                    />
                </div>
            )
                : (
                    <MobileProductFacetsV3
                        isFoodBrand={isFoodBrand}
                        productFacetsBase={productFacetsBase}
                        isFacetFiltersCountEnabled={isFacetFiltersCountEnabled}
                        category={category}
                        trackEventAction={trackEventAction}
                        categoryData={categoryData}
                        setFacetsDataInCollection={setFacetsDataInCollection}
                        svgIconData={svgIconData}
                        filterDialogData={filterDialogData}
                        abCategorySortAndFilter={abCategorySortAndFilter}
                        displayDeliveryMethod={displayDeliveryMethod}
                        presentation_family={presentation_family}
                        setFilterDataInCategoryBuilder={setFilterDataInCategoryBuilder}
                        openDisplayFacets
                        openFacetDropdown={openFacetDropdown}
                        checkedOptions={selectedFacet || checkedOptions}
                        setCheckedOptions={setCheckedOptions}
                        resetChecked={resetChecked}
                        productCount={productCount}
                        productDisplayLayout={productDisplayLayout}
                        forPlantGuide={forPlantGuide}
                        selectedFacet={selectedFacet}
                    />
                ))}
        </Media>
    );
};

MobileDesktopFacetsV3.propTypes = {
    classes: object.isRequired,
    isFoodBrand: bool.isRequired,
    productFacetsBase: arrayOf(shape({
        name: string,
        entries: arrayOf(shape({
            count: number,
            from: number,
            name: string,
            value: string,
        })),
    })),
    isFacetFiltersCountEnabled: bool.isRequired,
    filterFlag: bool.isRequired,
    category: shape({
        id: string,
        name: string,
        productFacets: arrayOf(shape({
            name: string,
            entries: arrayOf(shape({
                count: number,
                from: number,
                name: string,
                value: string,
            })),
        })),
    }),
    trackEventAction: func,
    categoryData: object.isRequired,
    abCategorySortAndFilter: object.isRequired,
    isFilterFactsV2: bool.isRequired,
    isDesktopFacetsV3: bool.isRequired,
    isMobileFacetsV3: bool.isRequired,
    featureFlags: object.isRequired,
    displayDeliveryMethod: object.isRequired,
    setFacetsDataInCollection: func.isRequired,
    setFilterDataInCategoryBuilder: func.isRequired,
    presentation_family: string.isRequired,
    openFacetDropdown: string.isRequired,
    setFacetLabel: func.isRequired,
    productCount: number,
    ssrDeviceType: string.isRequired,
    productDisplayLayout: bool.isRequired,
    selectedFacet: array,
    forPlantGuide: bool,
};

MobileDesktopFacetsV3.defaultProps = {
    productFacetsBase: [],
    category: {},
    trackEventAction: () => {},
    productCount: 0,
    selectedFacet: [],
    forPlantGuide: false,
};
const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
});
const enhance = compose(
    withRouter,
    connect(mapStateToProps, null),
);

export default enhance(MobileDesktopFacetsV3);
